import { ActivityAgeBand } from 'generated/graphql'

export const COLOR_LAST_BID = '#7B61FF'
export const COLOR_LAST_COMPLETED_JOB = '#0E9F9F'
export const SUPPLIER_ACTIVITY_RECENCY_CHART_HEIGHT = 300
export const SUPPLIER_ACTIVITY_RECENCY_WINDOWS: { value: number; label: string }[] = [
  { value: 90, label: '90 days' },
  { value: 180, label: '180 days' },
  { value: 365, label: '12 months' },
]
export const SUPPLIER_ACTIVITY_RECENCY_DEFAULT_WINDOW_DAYS = 90
export const SUPPLIER_ACTIVITY_AGE_BANDS: { value: ActivityAgeBand; label: string }[] = [
  { value: ActivityAgeBand.Months0To3, label: '0–3 months' },
  { value: ActivityAgeBand.Months3To6, label: '3–6 months' },
  { value: ActivityAgeBand.Months6To12, label: '6–12 months' },
]

export const SUPPLIER_ACTIVITY_RECENCY_INFO = [
  'Shows how recently suppliers last placed a bid or completed a job, helping identify ' +
    'active, at-risk, and dormant suppliers. It includes the cumulative share of suppliers ' +
    'active within the selected window and the average number of days since their last ' +
    'activity over time.',
  'Only active OnePoint suppliers with the Owner or Transport Controller role are included. ' +
    'Blocked suppliers and suppliers who have left the network are excluded. Each supplier ' +
    'is counted once per chart based on their most recent activity across the network. ' +
    'Figures are refreshed once daily, so recent activity may take up to approximately ' +
    '24 hours to appear.',
].join('\n\n')

export const SUPPLIER_ACTIVITY_RECENCY_FOOTNOTES = [
  'Each supplier is counted once per chart based on their most recent activity ' +
    'across the network. Blocked suppliers and suppliers that have left the ' +
    'network are excluded. Suppliers with mixed fleets are included in both HGV ' +
    'and Non-HGV, so these categories will not add up to the All total.',
  'Figures are refreshed once daily, so recent activity may take up to ' +
    'approximately 24 hours to appear.',
]

export const NETWORK_COUNT_INFO = [
  'The total number of suppliers covered by this page, including those who have never placed a ' +
    'bid or completed a job. The total reflects the selected vehicle type.',
  'Only OnePoint suppliers with the Owner or Transport Controller role who have completed ' +
    'onboarding and are currently active in the network are included.',
  'Courier Exchange suppliers, blocked suppliers, and suppliers who have left the network are ' +
    'excluded.',
].join('\n\n')

export const MEAN_DAILY_VALUES_INFO =
  'Shows the average number of days since suppliers last placed a bid or completed a job, for ' +
  'each of the last 90 days. The selected period determines which suppliers are included based ' +
  'on how recent their activity was on each day. Suppliers may move between periods as their ' +
  'activity changes. If no suppliers fall within the selected period on a given day, the chart ' +
  'shows a gap rather than zero.'

export const MEAN_DAILY_PERIOD_INFO =
  'Select suppliers based on how long it had been since their most recent activity on each day ' +
  'shown. For example, if a supplier’s last activity was 45 days ago, they are included in 0–3 ' +
  'months; 120 days ago, in 3–6 months; and 250 days ago, in 6–12 months. The period is ' +
  'recalculated for each day on the chart, so suppliers may move between periods over time.'

export const MEAN_DAILY_ENDPOINTS_INFO = [
  'Shows the average number of days since suppliers last placed a bid and last completed a ' +
    'job, measured at two points in time: Today and 90 days ago.',
  'For example, Today, 18.6 days means that suppliers in the selected period placed their most ' +
    'recent bid an average of 18.6 days ago. The 12.4 days value means they completed their most ' +
    'recent job an average of 12.4 days ago.',
  'At 90 days ago, the calculation looks at supplier activity as it stood on that date. At ' +
    'that point, suppliers had placed their most recent bid an average of 15.2 days before that ' +
    'date and completed their most recent job an average of 10.1 days before that date.',
  'The suppliers included can change from day to day because the selected period (for example, ' +
    '0–3 months) is applied separately to each day.',
].join('\n\n')
